var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import axios from "axios";
const username = "roadway@roadbotics.com";
const password = "roadbotics";
const config = {
    auth: {
        username,
        password,
    },
    responseType: "blob",
};
const baseUrl = "https://roadbotics-mappy.appspot.com";
axios.interceptors.response.use((response) => response, (error) => {
    return Promise.reject(error);
});
class MappyAPI {
    constructor() {
        this.getPointsGeoJson = (scanName) => __awaiter(this, void 0, void 0, function* () {
            const scanPointURL = `${baseUrl}/scan/${scanName}/rawquery?geojson_type=points`;
            const response = yield axios.get(scanPointURL, config);
            return response.data;
        });
        this.getSegmentsGeoJson = (scanName) => __awaiter(this, void 0, void 0, function* () {
            const scanPointURL = `${baseUrl}/scan/${scanName}/rawquery?geojson_type=segments`;
            const response = yield axios.get(scanPointURL, config);
            return response.data;
        });
        this.getSegmentsCSV = (scanName, isMetric = false, includeEPCI = false) => __awaiter(this, void 0, void 0, function* () {
            const scanPointCSVURL = `${baseUrl}/scan/${scanName}/segments_csv?metric=${isMetric}&epci=${includeEPCI}`;
            const response = yield axios.get(scanPointCSVURL, config);
            return response.data;
        });
        this.getShapefile = (scanId) => __awaiter(this, void 0, void 0, function* () {
            const scanShapefileURL = `${baseUrl}/scan/${scanId}/shapefile`;
            const response = yield axios.get(scanShapefileURL, config);
            return response.data;
        });
    }
}
export default MappyAPI;
